import { ExternalCompanyIdEnum } from '@/shared/constants/external-company-id.enum';

export const nativeClientStyles: any = {
  [ExternalCompanyIdEnum.SMG]: {
    logo: '/images/svenska/svenska_logo.png',
    fontFamily: 'GothamNarrowBook',
    primaryColor: '#859419',
  },
  [ExternalCompanyIdEnum.MSPECS]: {
    logo: '/images/mspecs/mspecs_logo.png',
    primaryColor: '#255a88',
  },
  [ExternalCompanyIdEnum.SORMEGLEREN]: {
    logo: '/images/sormegleren/logo.png',
    primaryColor: '#000',
  },
  [ExternalCompanyIdEnum.FREMEIENDOMSMEGLING]: {
    logo: '/images/fremeiendomsmegling/Native_Frem_Eiendomsmegling.png',
    primaryColor: 'rgb(244, 125, 75)',
  },
  [ExternalCompanyIdEnum.STRAND_MAKLERI]: {
    logo: '/images/strandmakleri/strand_logo.png',
    fontFamilyOne: 'Roboto',
    fontFamilyTwo: 'Montserrat',
    primaryColor: '#000',
  },
  [ExternalCompanyIdEnum.STUDIO_FASTIGHETSMAKLERI]: {
    logo: '/images/studiofastighetsmakleri/studio_logo.png',
    fontFamilyOne: 'Montserrat',
    fontFamilyTwo: 'Montserrat',
    primaryColor: '#5a7955',
  },
  [ExternalCompanyIdEnum.HOME_BY_DEAN]: {
    logo: '/images/homebydean/homebydean_logo.png',
    fontFamilyOne: 'ITCGaramondStd-LtCond',
    fontFamilyTwo: 'ITCGaramondStd-LtCond',
    primaryColor: '#aa0061',
  },
  [ExternalCompanyIdEnum.MAKLARTEAMET]: {
    logo: '/images/maklarteamet/maklarteamet.png',
    fontFamilyOne: 'Montserrat',
    fontFamilyTwo: 'Montserrat',
    primaryColor: '#74243b',
  },
  [ExternalCompanyIdEnum.WALLIN_CO_FASTIGHETSMAKLARE_AB]: {
    logo: '/images/Wallin/Wallin.jpg',
    fontFamilyOne: 'Playfair Display',
    fontFamilyTwo: 'Playfair Display',
    primaryColor: '#276e96',
  },
  [ExternalCompanyIdEnum.H_MAKLARE_AB]: {
    logo: '/images/hmaklare/hmaklare.png',
    fontFamilyOne: 'Roboto',
    fontFamilyTwo: 'Roboto',
    primaryColor: '#ac8811',
  },
  [ExternalCompanyIdEnum.CHRISTANDER]: {
    logo: '/images/christander/christander.jpg',
    fontFamilyOne: 'OpenSans-Regular, sans-serif, Arial',
    fontFamilyTwo: 'OpenSans-Regular, sans-serif, Arial',
    primaryColor: '#d0b67b',
  },
  [ExternalCompanyIdEnum.EIENDOM_BROERBY]: {
    logo: '/images/eiendom/eiendom.jpg',
    fontFamilyOne: 'Poppins, Sans-serif',
    fontFamilyTwo: 'Poppins, Sans-serif',
    primaryColor: '#010101',
  },
  [ExternalCompanyIdEnum.VISBYMAKLARNA_AB]: {
    logo: '/images/visbymaklarna/visbymaklarna.png',
    fontFamilyOne: 'Arial',
    fontFamilyTwo: 'Arial',
    primaryColor: '#5a5a5a',
  },
  [ExternalCompanyIdEnum.SKOG_LANTBRUK_AB]: {
    logo: '/images/skogochlantbruk/skogochlantbruk.svg',
    fontFamilyOne: 'Merriweather',
    fontFamilyTwo: 'Merriweather',
    primaryColor: '#52952c',
  },
  [ExternalCompanyIdEnum.LIWE_ESTATE]: {
    logo: '/images/liwe_estate/liwe_estate.png',
    fontFamilyOne: 'Montserrat',
    fontFamilyTwo: 'Montserrat',
    primaryColor: '#c79b3a',
  },
  [ExternalCompanyIdEnum.SJOLINSMAKLARE]: {
    logo: '/images/sjolinsmaklare/sjolinsmaklare.png',
    fontFamilyOne: 'Roboto',
    fontFamilyTwo: 'Roboto',
    primaryColor: '#1a294c',
  },
  [ExternalCompanyIdEnum.EMERA_EIE]: {
    logo: '/images/emera/emera_hovedlogo_beige.svg',
    fontFamilyOne: 'EMERARegular',
    fontFamilyTwo: 'EMERARegular',
    primaryColor: '#290F12',
  },
  [ExternalCompanyIdEnum.HETTINGER]: {
    logo: '/images/hettinger/hettinger.png',
    fontFamilyOne: 'Roboto',
    fontFamilyTwo: 'Roboto',
    primaryColor: '#787878',
  },
  [ExternalCompanyIdEnum.GRIPSHOLM]: {
    logo: '/images/gripsholms/gripsholms.jpg',
    fontFamilyOne: 'Montserrat',
    fontFamilyTwo: 'Montserrat',
    primaryColor: '#999',
  },
  [ExternalCompanyIdEnum.BOSTADSBYRAN]: {
    logo: '/images/bostadsbyran/bostadsbyran.png',
    fontFamilyOne: 'Roboto, Sans-serif',
    fontFamilyTwo: 'Roboto, Sans-serif',
    primaryColor: '#444444',
  },
};
